import React from "react";
import "./styles/About.css";

const About = () => {
  return (
    <section id="about" className="about-section">
      <div className="about-content">
        <h2>About Me</h2>
        <div className="about-text">
          <p>
            Software development student with hands-on practise in NestJS, Node.js, React, and Docker. Curious about
            AI-powered applications and motivated to explore LLM integrations and intelligent automation. Looking for a
            PFE internship to grow my skills and contribute to modern, AI-enhanced projects.
          </p>
        </div>
      </div>
    </section>
  );
};

export default About;
